import React from "react";
import { Layers, Check } from "lucide-react";

const chf = (v) => (v == null ? "–" : `CHF ${Number(v).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const d = (s) => (s ? new Date(s).toLocaleDateString("de-CH") : "–");

/** Panel im Notiz-Dialog: ähnliche offene Belege (gleicher Lieferant / gleiches Dateimuster) – Notiz auf alle anwenden. */
export function SimilarItemsPanel({ similar, selected, onToggle, onToggleAll }) {
  if (!similar || !similar.items?.length) return null;
  const all = similar.items.length > 0 && selected.size === similar.items.length;
  const label = similar.basis === "supplier" ? `von ${similar.supplier}` : "mit gleichem Dateinamen-Muster";
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/70" data-testid="inbox-note-similar">
      <div className="flex items-center justify-between gap-2 px-3 py-2">
        <div className="flex items-center gap-2 text-xs text-amber-900">
          <Layers className="h-4 w-4 text-amber-600 shrink-0" />
          <span data-testid="inbox-note-similar-count"><b>{similar.items.length} ähnliche Belege</b> {label} im Posteingang</span>
        </div>
        <button type="button" onClick={onToggleAll} data-testid="inbox-note-similar-toggle-all"
          className={`flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium transition-colors ${all ? "bg-amber-600 text-white" : "border border-amber-300 bg-white text-amber-800 hover:bg-amber-100"}`}>
          {all && <Check className="h-3 w-3" />}{all ? "Für alle übernehmen" : "Alle auswählen"}
        </button>
      </div>
      <ul className="max-h-36 overflow-auto border-t border-amber-100 divide-y divide-amber-100" data-testid="inbox-note-similar-list">
        {similar.items.map((s) => (
          <li key={s.id}>
            <label className="flex items-center gap-2 px-3 py-1.5 text-xs cursor-pointer hover:bg-amber-100/60">
              <input type="checkbox" checked={selected.has(s.id)} onChange={() => onToggle(s.id)} className="accent-amber-600" data-testid={`inbox-note-similar-check-${s.id}`} />
              <span className="w-20 shrink-0 text-slate-600">{d(s.invoice_date)}</span>
              <span className="flex-1 truncate text-slate-800">{s.invoice_number || s.file_name}</span>
              {s.user_note && <span className="truncate max-w-[120px] text-slate-400 italic" title={s.user_note}>«{s.user_note}»</span>}
              <span className="font-medium whitespace-nowrap">{chf(s.total_amount)}</span>
            </label>
          </li>
        ))}
      </ul>
      {selected.size > 0 ? (
        <div className="px-3 py-1.5 text-[11px] text-amber-800 border-t border-amber-100" data-testid="inbox-note-similar-hint">
          Notiz, Konto-Vorschlag und Gutschrift-Markierung gelten für diesen + {selected.size} weitere Belege.
        </div>
      ) : (
        <div className="px-3 py-1.5 text-[11px] text-slate-500 border-t border-amber-100" data-testid="inbox-note-similar-hint">
          Nur dieser Beleg – andere bei Bedarf anhaken.
        </div>
      )}
    </div>
  );
}
